export var groupIntegrations = function groupIntegrations(acc, integration) {
  if (integration._distinctSeqID === 0 || integration._distinctSeqID === undefined) {
    var _integration$categori, _integration$categori2;

    var category = (_integration$categori = integration.categories) === null || _integration$categori === void 0 ? void 0 : (_integration$categori2 = _integration$categori[0]) === null || _integration$categori2 === void 0 ? void 0 : _integration$categori2.category;

    if (category && category.name && category.slug) {
      acc.push({
        category: {
          name: category.name,
          slug: category.slug
        },
        integrations: [integration]
      });
    } else {
      acc.push({
        integrations: [integration]
      });
    }
  } else if (acc.length > 0) {
    acc[acc.length - 1].integrations.push(integration);
  } else {
    throw new Error("Invalid algolia response. Hits sequence isn't starting with _distinctSeqID=0");
  }

  return acc;
};